import {Component, Inject} from '@angular/core';
import {L10N_LOCALE, L10nLocale} from 'angular-l10n';
import {Observable} from 'rxjs';
import {Role} from '../../../shared';
import {select, Store} from '@ngrx/store';
import * as fromShared from '../../../shared/reducers';
import {map} from 'rxjs/operators';
import * as _ from 'lodash';

@Component({ selector: 'storever-not-found', templateUrl: './not-found.component.html', styleUrls: ['./not-found.component.scss'] })
export class NotFoundComponent {
  roles$: Observable<Role[]>;

  constructor(@Inject(L10N_LOCALE) public locale: L10nLocale, private store: Store<fromShared.AppState>) {
    this.roles$ = this.store.pipe(select(fromShared.selectors.getMyRoles));
  }

  isInRole$(role: string): Observable<boolean> {
    return this.roles$.pipe(map(roles => _.findIndex(roles, ['code', role]) > -1));
  }
}
